import { mapActions, mapGetters } from 'vuex'

export default {
	template: '<router-view />',

	beforeRouteEnter(to, from, next) {
		next(vm => {
			if (vm.store) {
				vm.fetchCommissions({
					no_paginate: true,
					store: {
						id: vm.storeId || vm.store.id
					}
				})
			} else {
				vm.$router.push({name: 'stores'})
			}
		})
	},

	data() {
		return {
			storeId: this.$route.params.store_id
		}
	},

	computed: {
        ...mapGetters({
            stores: 'store/stores',
        }),

		store() {
			return this.stores[this.storeId] || this.$currentUser().store || null
		}
	},

	methods: {
		...mapActions({
			fetchCommissions: 'v2commission/fetch',
		}),
	}
}